module.exports = function(app) {
	app.filter('oiSelectSearchFilter', ['$sce', function($sce) {
    return function(label, query, item, options, element) {

        var html = '<div title="Remove author">'+ label + ' <span class="select-search-email">(' + item.email + ')</span><span class="close select-search-list-item_selection-remove">×</span></div>';

        return $sce.trustAsHtml(html);
    };
	}])
	app.filter('oiSelectDropdownFilter', ['$sce', function($sce) {
	    return function(label, query, item, options, element) {

	        var html = label + ' <span class="select-search-email">(' + item.email + ')</span>';

	        return $sce.trustAsHtml(html);
	 };
	}])	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/filter/oiSelectFilters.js
// module id = 457
// module chunks = 0